import React from 'react';

import Breadcumb from './Breadcumb';
import Testimonials from './Testimonials';

function Main() {
  return (
    <>
      <Breadcumb />
      <Testimonials />
    </>
  );
}

export default Main;
